/* Pufciaki - motyw Shopify. Logika 1:1 z landingu, koszyk na prawdziwym koszyku Shopify (AJAX: /cart.js, /cart/add.js, /cart/change.js).
   Bez własnych pikseli i śledzenia: TikTok/Meta podpina się aplikacjami Shopify. */
(function(){
  'use strict';
  var K = window.PF || {};
  var redukcja = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function $(id){ return document.getElementById(id); }
  function wpisz(id, t){ var e = $(id); if(e) e.textContent = t; }
  function zl(g){ return (Math.round(g) / 100).toFixed(2).replace('.', ',') + ' zł'; }
  var SZT = K.sztukWZestawie || 6, JEDN = K.jednostka || 'gniotków';
  /* wersje produktu (warianty): dane z sekcji zakupu, odmiana słów, Duo = 2 pierwsze wersje razem */
  var WAR = []; try{ WAR = JSON.parse(($('pfWarianty') || {}).textContent || '[]'); }catch(e){}
  var PRODW = WAR.length ? WAR.map(function(w){ return String(w.id); }) : [String(K.wariant)];
  var WYB = null; WAR.forEach(function(w){ if(String(w.id) === String(K.wariant)) WYB = w; });
  function odm(n, f1, f2){ var j = n % 10, s = n % 100; return n + ' ' + (j >= 2 && j <= 4 && (s < 12 || s > 14) ? f1 : (f2 || f1)); }
  function ileJedn(n){ return WYB ? odm(n, WYB.f1, WYB.f2) : n + ' ' + JEDN; }
  function duoOk(){ return WAR.length > 1 && WAR[0].ok && WAR[1].ok; }
  function cenaDuo(){ return WAR[0].cena + WAR[1].cena - rabatZa(2); }
  function rabatZa(n){ var r = 0; (K.rabaty || []).forEach(function(x){ if(!r && x[1] > 0 && n >= x[0]) r = x[1]; }); return r; }
  function cenaZa(n){ return n * (K.cena || 0) - rabatZa(n); }

  /* ══ OCHRONA TREŚCI: bez kopiowania tekstu, prawego przycisku i przeciągania zdjęć (pola formularzy działają) ══ */
  function wPolu(e){ var t = e.target; return t && t.closest && t.closest('input,textarea,select,[contenteditable="true"]'); }
  if(!window.Shopify || !Shopify.designMode){
    ['copy', 'cut', 'contextmenu', 'selectstart'].forEach(function(ev){ document.addEventListener(ev, function(e){ if(!wPolu(e)) e.preventDefault(); }, true); });
    document.addEventListener('dragstart', function(e){ if(e.target && /^(IMG|VIDEO|PICTURE|CANVAS|A)$/.test(e.target.tagName)) e.preventDefault(); }, true);
  }

  /* ══ KOSZYK SHOPIFY ══ */
  var panel = $('koszyk'), zaslona = $('zaslona'), kasa = $('koszyk-kasa'), lista = $('koszyk-lista');
  var koszyk = { items: [], item_count: 0, total_price: 0, original_total_price: 0, total_discount: 0 };
  function api(url, dane){
    var o = dane ? { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(dane) } : { headers: { 'Accept': 'application/json' } };
    return fetch(url, o).then(function(r){ return r.json().then(function(j){ if(!r.ok) throw j; return j; }); });
  }
  function pobierzKoszyk(){ return api((K.cartUrl || '/cart') + '.js').then(function(c){ koszyk = c; rysujKosz(); return c; }); }
  function ileSzt(){ return koszyk.items.reduce(function(a, i){ return a + (PRODW.indexOf(String(i.variant_id)) > -1 ? i.quantity : 0); }, 0); }

  var kz = $('kzgody'), zgodyLi = [].slice.call(document.querySelectorAll('#kzgody-tor .kzgoda')), stan = $('kzgody-stan');
  function zgodyOk(){ return !kz || kz.classList.contains('kzgody--ok'); }
  function odswiezKase(){
    var pusty = !koszyk.item_count;
    kasa.setAttribute('aria-disabled', String(!zgodyOk() || pusty));
    if(kz) kz.style.display = pusty ? 'none' : '';
  }
  /* okienko zgód: dokładnie 2 pierwsze widoczne, reszta po przewinięciu */
  function dopasujZgody(){
    var tor = $('kzgody-tor');
    if(!tor || zgodyLi.length < 3 || !tor.offsetHeight) return;
    tor.style.maxHeight = 'none';
    var h = zgodyLi[1].offsetTop + zgodyLi[1].offsetHeight - zgodyLi[0].offsetTop;
    tor.style.maxHeight = (h + 3) + 'px';
  }
  function odswiezZgody(){
    if(!kz) return;
    var ile = zgodyLi.filter(function(li){ return li.classList.contains('kzgoda--on'); }).length;
    var wszystkie = ile === zgodyLi.length, tekst = ile + '/' + zgodyLi.length;
    if($('kzgody-licznik').textContent !== tekst){
      wpisz('kzgody-licznik', tekst);
      stan.classList.remove('kzgody__stan--skok'); void stan.offsetWidth; stan.classList.add('kzgody__stan--skok');
    }
    stan.classList.toggle('kzgody__stan--ok', wszystkie);
    kz.classList.toggle('kzgody--ok', wszystkie);
    wpisz('kzgody-etykieta', wszystkie ? 'Warunki zaakceptowane' : 'Akceptuję wszystkie warunki');
    odswiezKase();
  }
  function ustawZgode(li, on){ li.classList.toggle('kzgoda--on', on); li.setAttribute('aria-checked', String(on)); }
  zgodyLi.forEach(function(li){
    li.addEventListener('click', function(e){ if(e.target.closest('a')) return; ustawZgode(li, !li.classList.contains('kzgoda--on')); odswiezZgody(); });
    li.addEventListener('keydown', function(e){ if(e.key === ' ' || e.key === 'Enter'){ e.preventDefault(); li.click(); } });
  });
  if($('kzgody-wszystkie')) $('kzgody-wszystkie').addEventListener('click', function(){
    zgodyLi.filter(function(li){ return !li.classList.contains('kzgoda--on'); }).forEach(function(li, i){
      setTimeout(function(){ ustawZgode(li, true); odswiezZgody(); }, redukcja ? 0 : i * 90);
    });
  });
  kasa.addEventListener('click', function(e){
    if(kasa.getAttribute('aria-disabled') === 'true'){
      e.preventDefault();
      var b = $('kzgody-wszystkie');
      if(b && koszyk.item_count){
        b.classList.add('kzgody__wszystkie--blad');
        setTimeout(function(){ b.classList.remove('kzgody__wszystkie--blad'); }, 460);
        b.scrollIntoView({ behavior: redukcja ? 'auto' : 'smooth', block: 'center' });
      }
    }
  });

  var SVG_X = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3.4" stroke-linecap="round"><path d="m18 6-12 12M6 6l12 12"/></svg>';
  function esc(s){ return String(s == null ? '' : s).replace(/[&<>"]/g, function(c){ return { '&':'&amp;', '<':'&lt;', '>':'&gt;', '"':'&quot;' }[c]; }); }
  function rysujKosz(){
    if(!koszyk.items.length){
      lista.innerHTML = '<div class="koszyk__pusty"><b>Koszyk czeka na Pufciaki</b>Jeden zestaw to ' + ileJedn(SZT) + '.' +
        (K.wariant ? '<br><button type="button" class="btn" data-dodaj="1">Dodaj zestaw · ' + zl(K.cena) + '</button>' : '') + '</div>';
    } else {
      lista.innerHTML = koszyk.items.map(function(it, i){
        var wIt = null; WAR.forEach(function(w){ if(String(w.id) === String(it.variant_id)) wIt = w; });
        var st = wIt ? wIt.stara : (String(it.variant_id) === String(K.wariant) ? K.stara : 0), porownawcza = st > it.price ? st * it.quantity : 0;
        var stara = porownawcza ? '<s>' + zl(porownawcza) + '</s>' : '';
        var img = it.image ? it.image + (it.image.indexOf('?') > -1 ? '&' : '?') + 'width=200&height=200&crop=center' : '';
        var dw = (K.warianty || {})[String(it.variant_id)], opis = (it.variant_title && WAR.length ? esc(it.variant_title) + ' · ' : '') + (dw && dw[0] > 1 ? esc(odm(it.quantity * dw[0], dw[1], dw[2])) : esc(it.variant_title || ''));
        return '<div class="koszyk__pozycja">' +
          '<button type="button" class="koszyk__usun" data-linia="' + (i + 1) + '" data-ile="0" aria-label="Usuń z koszyka">' + SVG_X + '</button>' +
          '<div class="koszyk__foto">' + (img ? '<img src="' + esc(img) + '" alt="" decoding="async">' : '') + '</div>' +
          '<div class="koszyk__opis">' +
            '<p class="koszyk__nazwa">' + esc(it.product_title) + '</p>' +
            '<p class="koszyk__typ">' + opis + '</p>' +
            '<div class="koszyk__ilosc"><button type="button" data-linia="' + (i + 1) + '" data-ile="' + (it.quantity - 1) + '" aria-label="Zmniejsz ilość">−</button><span aria-live="polite">' + it.quantity + '</span><button type="button" data-linia="' + (i + 1) + '" data-ile="' + (it.quantity + 1) + '" aria-label="Zwiększ ilość">+</button></div>' +
          '</div>' +
          '<div class="koszyk__cena">' + stara + zl(it.original_line_price) + '</div>' +
        '</div>';
      }).join('');
    }
    /* rabat: z kasy Shopify (rabaty automatyczne); gdy jeszcze go nie ma, pokazujemy wyliczony z ustawień motywu */
    var n = ileSzt(), rabatKasy = (koszyk.original_total_price || 0) - (koszyk.total_price || 0), r = rabatKasy > 0 ? rabatKasy : rabatZa(n);
    $('koszyk-rabat').hidden = !r;
    if(r){ wpisz('koszyk-rabat-kwota', '-' + zl(r)); wpisz('koszyk-rabat-opis', n >= 2 ? 'Rabat za ' + (n >= 3 ? '3 zestawy' : '2 zestawy') : 'Rabat'); }
    wpisz('koszyk-ile', String(koszyk.item_count));
    wpisz('koszyk-suma', zl(rabatKasy > 0 ? koszyk.total_price : (koszyk.original_total_price || koszyk.total_price) - r));
    var bab = $('nag-bab'); bab.textContent = koszyk.item_count; bab.hidden = !koszyk.item_count;
    var podp = $('koszyk-podp');
    /* podpowiedź: przy wersjach proponujemy tę, której jeszcze nie ma w koszyku */
    var inna = null;
    if(WAR.length > 1) WAR.forEach(function(w){ if(!inna && w.ok && !koszyk.items.some(function(i){ return String(i.variant_id) === String(w.id); })) inna = w; });
    if(K.wariant && (n === 1 || n === 2) && rabatZa(n + 1) > rabatZa(n)){
      var pw = inna || WYB || { id: K.wariant, cena: K.cena, szt: SZT, t: '' };
      var dop = pw.cena - (rabatZa(n + 1) - rabatZa(n));
      podp.innerHTML = '<span><b>' + (inna ? 'Dodaj ' + esc(inna.t) + ' za ' : (n === 1 ? 'Drugi' : 'Trzeci') + ' zestaw za ') + zl(dop) + '</b><br>Oszczędzasz ' + zl(pw.cena - dop) + ' · +' + (pw.f1 ? odm(pw.szt, pw.f1, pw.f2) : SZT + ' ' + JEDN) + '</span><button type="button" data-dodaj="1" data-id="' + pw.id + '">Dodaj</button>';
      podp.hidden = false;
    } else podp.hidden = true;
    odswiezKase();
    if(!panel.hidden) requestAnimationFrame(dopasujZgody);
  }
  function laduje(on){ panel.classList.toggle('koszyk--laduje', on); }
  lista.addEventListener('click', function(e){
    var b = e.target.closest('button[data-linia]');
    if(!b) return;
    laduje(true);
    api((K.cartChangeUrl || '/cart/change') + '.js', { line: Number(b.getAttribute('data-linia')), quantity: Math.max(0, Math.min(Number(b.getAttribute('data-ile')), 20)) })
      .then(function(c){ koszyk = c; rysujKosz(); }).catch(function(){ pobierzKoszyk(); }).then(function(){ laduje(false); });
  });
  function dodaj(n, id){
    if(!K.wariant) return Promise.resolve();
    laduje(true);
    var items = Array.isArray(n) ? n : n === 'duo' && duoOk() ? [{ id: WAR[0].id, quantity: 1 }, { id: WAR[1].id, quantity: 1 }] : [{ id: id || K.wariant, quantity: Math.max(1, Math.min(n || 1, 20)) }];
    if(!items.length){ laduje(false); return Promise.resolve(); }
    return api((K.cartAddUrl || '/cart/add') + '.js', { items: items })
      .then(pobierzKoszyk)
      .catch(function(err){ alert((err && (err.description || err.message)) || 'Nie udało się dodać do koszyka. Spróbuj jeszcze raz.'); })
      .then(function(){ laduje(false); });
  }

  /* otwieranie i zamykanie szuflady z blokadą przewijania tła */
  var pozycjaScrolla = 0;
  function otworz(){
    pozycjaScrolla = window.scrollY;
    panel.hidden = false; zaslona.hidden = false;
    requestAnimationFrame(function(){ panel.classList.add('koszyk--widac'); zaslona.classList.add('zaslona--widac'); dopasujZgody(); });
    document.body.style.top = '-' + pozycjaScrolla + 'px';
    document.body.classList.add('blokada');
  }
  function zamknij(){
    if(!panel.classList.contains('koszyk--widac')) return;
    panel.classList.remove('koszyk--widac'); zaslona.classList.remove('zaslona--widac');
    document.body.classList.remove('blokada'); document.body.style.top = '';
    window.scrollTo(0, pozycjaScrolla);
    setTimeout(function(){ panel.hidden = true; zaslona.hidden = true; }, 380);
  }
  $('koszyk-zamknij').addEventListener('click', zamknij);
  zaslona.addEventListener('click', zamknij);
  document.addEventListener('keydown', function(e){ if(e.key === 'Escape') zamknij(); });
  $('gora-kosz').addEventListener('click', function(e){ e.preventDefault(); pobierzKoszyk(); otworz(); });
  panel.addEventListener('click', function(e){
    var b = e.target.closest('[data-dodaj]');
    if(b){ e.preventDefault(); dodaj(Number(b.getAttribute('data-dodaj')) || 1, b.getAttribute('data-id')); }
  });

  /* ══ MENU Z BOKU ══ */
  var menu = $('menu'), menuBtn = $('menu-otworz'), menuScroll = 0;
  function otworzMenu(){
    menuScroll = window.scrollY;
    menu.hidden = false; menuBtn.setAttribute('aria-expanded', 'true');
    requestAnimationFrame(function(){ requestAnimationFrame(function(){ menu.classList.add('menu--widac'); }); });
    document.body.style.top = '-' + menuScroll + 'px'; document.body.classList.add('blokada');
  }
  function zamknijMenu(natychmiast){
    if(menu.hidden) return;
    menu.classList.remove('menu--widac'); menuBtn.setAttribute('aria-expanded', 'false');
    document.body.classList.remove('blokada'); document.body.style.top = '';
    window.scrollTo(0, menuScroll);
    if(natychmiast) menu.hidden = true; else setTimeout(function(){ menu.hidden = true; }, 330);
  }
  if(menu && menuBtn){
    menuBtn.addEventListener('click', otworzMenu);
    menu.querySelectorAll('[data-menu-zamknij]').forEach(function(x){ x.addEventListener('click', function(){ zamknijMenu(); }); });
    menu.addEventListener('click', function(e){
      if(e.target.closest('[data-menu-kosz]')){ zamknijMenu(true); pobierzKoszyk(); otworz(); return; }
      if(e.target.closest('a')) zamknijMenu(true);
    }, true);
    document.addEventListener('keydown', function(e){ if(e.key === 'Escape') zamknijMenu(); });
  }

  /* bez animacji lotu: koszyk otwiera się od razu (z ładowaniem), produkt dopisuje się, gdy odpowie Shopify; ważne przy słabym internecie */
  function dodajIOtworz(n){
    otworz();
    dodaj(n).then(function(){ var bab = $('nag-bab'); bab.classList.remove('skok'); void bab.offsetWidth; bab.classList.add('skok'); });
  }

  /* ══ GALERIA ZDJĘĆ (miniatury, strzałki, przesunięcie palcem) ══ */
  var fot = $('podglad'), gal = $('galeria-mini'), nrFoto = 0;
  var FOT = gal ? [].map.call(gal.querySelectorAll('button'), function(b){ return { src: b.getAttribute('data-src'), srcset: b.getAttribute('data-srcset') || '', alt: b.getAttribute('data-alt') || '', wersja: b.getAttribute('data-wersja') }; }) : [];
  FOT.forEach(function(f, i){ if(gal.children[i].getAttribute('aria-pressed') === 'true') nrFoto = i; });
  /* zmiana zdjęcia przez klienta (miniatura, strzałka, palec); przy zestawiaczu zmienia też wybraną wersję */
  var naZdjecieWersji = null;
  function fotoKlient(i){ pokazFoto(i); var w = FOT[nrFoto] && FOT[nrFoto].wersja; if(w && naZdjecieWersji) naZdjecieWersji(w); }
  function pokazFoto(i){
    if(!fot || !FOT.length) return;
    nrFoto = (i + FOT.length) % FOT.length;
    var f = FOT[nrFoto];
    fot.removeAttribute('sizes'); fot.srcset = f.srcset; fot.src = f.src; fot.alt = f.alt;
    if(f.srcset) fot.sizes = '(min-width:960px) 600px, 92vw';
    gal.querySelectorAll('button').forEach(function(b, k){ b.setAttribute('aria-pressed', String(k === nrFoto)); });
    var akt = gal.children[nrFoto]; if(akt) gal.scrollTo({ left: akt.offsetLeft - gal.offsetWidth / 2 + akt.offsetWidth / 2, behavior: redukcja ? 'auto' : 'smooth' });
  }
  if(gal && fot){
    gal.addEventListener('click', function(e){ var b = e.target.closest('button'); if(b) fotoKlient([].indexOf.call(gal.children, b)); });
    $('fotoL').addEventListener('click', function(){ fotoKlient(nrFoto - 1); });
    $('fotoP').addEventListener('click', function(){ fotoKlient(nrFoto + 1); });
    var x0 = null;
    fot.parentNode.addEventListener('touchstart', function(e){ x0 = e.touches[0].clientX; }, { passive: true });
    fot.parentNode.addEventListener('touchend', function(e){ if(x0 === null) return; var d = e.changedTouches[0].clientX - x0; if(Math.abs(d) > 40) fotoKlient(nrFoto + (d < 0 ? 1 : -1)); x0 = null; }, { passive: true });
    addEventListener('load', function(){ setTimeout(function(){ FOT.forEach(function(f){ var im = new Image(); im.src = f.src; }); }, 1500); });
  }

  /* ══ PAKIETY 1 / 2 / 3 ZESTAWY ══ */
  var pak = $('pakiety'), wybranych = pak && pak.querySelector('[data-n="duo"]') ? 'duo' : 2;
  function nN(b){ var v = b.getAttribute('data-n'); return v === 'duo' ? v : Number(v); }
  function rysujPakiet(){
    if(!pak) return;
    pak.querySelectorAll('[data-n]').forEach(function(b){ var on = nN(b) === wybranych; b.setAttribute('aria-checked', String(on)); b.tabIndex = on ? 0 : -1; });
    var duo = wybranych === 'duo';
    var bt = $('doKoszyka');
    if(bt && !bt.disabled) wpisz('kupBtnTxt', duo ? 'Dodaj oba zestawy do koszyka' : wybranych === 1 ? 'Dodaj do koszyka' : 'Dodaj ' + wybranych + ' zestawy do koszyka');
    var nazwa = $('stickyModel'); if(nazwa && !nazwa.dataset.baza) nazwa.dataset.baza = nazwa.textContent;
    var baza = nazwa ? nazwa.dataset.baza.split(' · ')[0] : '';
    if(nazwa) nazwa.textContent = duo ? 'Duo · ' + WAR[0].t + ' + ' + WAR[1].t : (wybranych === 1 ? (WYB ? baza + ' ' + WYB.t + ' · ' + ileJedn(SZT) : nazwa.dataset.baza) : wybranych + ' zestawy · ' + ileJedn(wybranych * SZT));
    var sc = $('stickyCena');
    if(sc) sc.innerHTML = duo ? zl(cenaDuo()) + '<s>' + zl(WAR[0].cena + WAR[1].cena) + '</s>' : zl(cenaZa(wybranych)) + (wybranych === 1 ? (K.stara > K.cena ? '<s>' + zl(K.stara) + '</s>' : '') : '<s>' + zl(wybranych * K.cena) + '</s>');
    document.querySelectorAll('.promo[data-pakiet="duo"]').forEach(function(p){ p.classList.toggle('promo--on', duo); });
  }
  /* zmiana wersji: ceny w pakietach, cena, zdjęcie, adres strony */
  function cenyPakietow(){
    if(!pak) return;
    pak.querySelectorAll('[data-n]').forEach(function(b){
      var n = nN(b); if(n === 'duo') return;
      var bez = n * K.cena, rab = rabatZa(n), za = bez - rab, c = b.querySelector('.pakiet__cena'), o = b.querySelector('.pakiet__opis small');
      if(c) c.innerHTML = '<b>' + zl(za) + '</b>' + (n === 1 ? (K.stara > K.cena ? '<s>' + zl(K.stara) + '</s>' : '') : '<s>' + zl(bez) + '</s><span>' + zl(za / n) + ' / zestaw</span>');
      if(o) o.textContent = ileJedn(n * SZT) + (rab > 0 ? ' · oszczędzasz ' + zl(rab) : '');
    });
  }
  function wybierzWariant(id, cicho){
    var w = null; WAR.forEach(function(x){ if(String(x.id) === String(id)) w = x; });
    if(!w) return;
    WYB = w; K.wariant = w.id; K.cena = w.cena; K.stara = w.stara; SZT = w.szt;
    document.querySelectorAll('#warianty [data-wariant]').forEach(function(b){ var on = b.getAttribute('data-wariant') === String(w.id); b.setAttribute('aria-checked', String(on)); b.tabIndex = on ? 0 : -1; });
    var ct = $('cenaTeraz'); if(ct) ct.textContent = zl(w.cena);
    if(wybranych === 'duo' && !cicho) wybranych = 1;
    cenyPakietow(); rysujPakiet();
    if(w.img && gal){ var k = -1; gal.querySelectorAll('button').forEach(function(b, i){ if(k < 0 && b.getAttribute('data-src') === w.img) k = i; }); if(k > -1) pokazFoto(k); }
    try{ var u = new URL(location.href); u.searchParams.set('variant', w.id); history.replaceState(null, '', u); }catch(er){}
  }
  var warEl = $('warianty');
  if(warEl){
    warEl.addEventListener('click', function(e){ var b = e.target.closest('[data-wariant]'); if(b && !b.disabled){ wybierzWariant(b.getAttribute('data-wariant')); b.classList.remove('hop'); void b.offsetWidth; b.classList.add('hop'); } });
    if(WYB){ SZT = WYB.szt; cenyPakietow(); }
  }
  /* przyciski w innych sekcjach: data-wybierz-wariant="Safari", data-pakiet="duo", data-dodaj-duo */
  document.addEventListener('click', function(e){
    var a = e.target.closest('[data-wybierz-wariant]'), p = e.target.closest('[data-pakiet]'), d = e.target.closest('[data-dodaj-duo]');
    if(a){ var t = a.getAttribute('data-wybierz-wariant').toLowerCase(); WAR.forEach(function(w){ if(w.t.toLowerCase() === t) wybierzWariant(w.id); }); if(wybranych === 'duo'){ wybranych = 1; rysujPakiet(); } }
    if(p && pak){
      e.preventDefault(); wybranych = p.getAttribute('data-pakiet') === 'duo' ? 'duo' : Number(p.getAttribute('data-pakiet')); rysujPakiet();
      var cel = pak.querySelector('[data-n="' + wybranych + '"]');
      if(cel){ cel.classList.remove('hop'); void cel.offsetWidth; cel.classList.add('hop'); }
      if(!p.closest('.pkup')) $('kup').scrollIntoView({ behavior: redukcja ? 'auto' : 'smooth', block: 'start' });
    }
    if(d && duoOk()){ e.preventDefault(); dodajIOtworz('duo', d); }
  });
  if(pak){
    pak.addEventListener('click', function(e){ var b = e.target.closest('[data-n]'); if(b){ wybranych = nN(b); rysujPakiet(); } });
    pak.addEventListener('keydown', function(e){
      var k = { ArrowDown: 1, ArrowRight: 1, ArrowUp: -1, ArrowLeft: -1 }[e.key];
      if(!k) return;
      var bs = [].slice.call(pak.querySelectorAll('[data-n]')), i = bs.map(nN).indexOf(wybranych);
      e.preventDefault(); var nb = bs[Math.max(0, Math.min(bs.length - 1, i + k))]; wybranych = nN(nb); rysujPakiet(); nb.focus();
    });
    rysujPakiet();
    var dodajWybrane = function(e){ e.preventDefault(); dodajIOtworz(wybranych, this); };
    if($('doKoszyka')) $('doKoszyka').addEventListener('click', dodajWybrane);
    if($('stickyDodaj')) $('stickyDodaj').addEventListener('click', dodajWybrane);
  }

  /* ══ ZESTAWIACZ: dowolne wersje plusem i minusem, progi rabatu, cena za zestaw na żywo ══ */
  var ZST = $('zestawiacz');
  if(ZST && WAR.length){
    var ILE = {}, KOLEJ = [], ost = null, MAX_W = 10, MAX_RAZEM = 20;
    var PROGI = [].slice.call(ZST.querySelectorAll('[data-prog]')), MAXP = PROGI.length ? Number(PROGI[PROGI.length - 1].getAttribute('data-prog')) : 3;
    var wInfo = function(id){ var w = null; WAR.forEach(function(x){ if(String(x.id) === String(id)) w = x; }); return w; };
    var suma = function(){ return Object.keys(ILE).reduce(function(a, k){ return a + ILE[k]; }, 0); };
    var zlk = function(g){ return zl(g).replace(',00 ', ' '); };
    var zestawy = function(n){ return n === 1 ? '1 zestaw' : odm(n, 'zestawy', 'zestawów'); };
    var skok = function(el, kl){ if(!el || redukcja) return; kl = kl || 'hop'; el.classList.remove(kl); void el.offsetWidth; el.classList.add(kl); };
    var konfetti = function(el){
      if(redukcja || !el || !Element.prototype.animate) return;
      var r = el.getBoundingClientRect();
      for(var i = 0; i < 14; i++){
        var s = document.createElement('span'); s.className = 'iskra iskra--fix';
        var kat = -Math.PI / 2 + (Math.random() - .5) * 2.4, d = 50 + Math.random() * 70;
        s.style.background = KOL[i % KOL.length]; s.style.left = (r.left + r.width / 2 - 5) + 'px'; s.style.top = (r.top + r.height / 3) + 'px';
        document.body.appendChild(s);
        s.animate([{ transform: 'translate(0,0) scale(1)', opacity: 1 }, { transform: 'translate(' + Math.cos(kat) * d + 'px,' + (Math.sin(kat) * d + 40) + 'px) scale(.3) rotate(' + (Math.random() * 360) + 'deg)', opacity: 0 }],
          { duration: 700 + Math.random() * 300, easing: 'cubic-bezier(.2,.7,.3,1)' }).onfinish = (function(x){ return function(){ x.remove(); }; })(s);
      }
    };
    var pokazWersje = function(w){
      if(!w || !w.img || !gal) return;
      var k = -1; gal.querySelectorAll('button').forEach(function(b, i){ if(k < 0 && b.getAttribute('data-src') === w.img) k = i; });
      if(k > -1 && k !== nrFoto) pokazFoto(k);
    };
    /* pasek „co jest w pudełku”: przewija się do wersji, którą klient właśnie wybiera */
    var pudlaTor = $('pudlaTor');
    var przewinPudlo = function(id, od_razu){
      if(!pudlaTor) return;
      var k = pudlaTor.querySelector('[data-wersja="' + id + '"]'); if(!k) return;
      pudlaTor.querySelectorAll('.pudlo').forEach(function(x){ x.classList.toggle('pudlo--on', x === k); });
      pudlaTor.scrollTo({ left: k.offsetLeft - (pudlaTor.clientWidth - k.offsetWidth) / 2, behavior: od_razu || redukcja ? 'auto' : 'smooth' });
    };
    var rysujZst = function(nowy, przed){
      var t = suma(), bez = 0, wybrane = [];
      WAR.forEach(function(w){ var n = ILE[w.id] || 0; bez += n * w.cena; if(n) wybrane.push(w); });
      var rab = rabatZa(t), razem = bez - rab;
      ZST.querySelectorAll('.zw[data-w]').forEach(function(z){
        var n = ILE[z.getAttribute('data-w')] || 0;
        z.classList.toggle('zw--on', n > 0);
        var o = z.querySelector('output'); if(o) o.textContent = n;
        var b = z.querySelector('.zw__ile'); if(b) b.textContent = n;
        var minus = z.querySelector('[data-zw="-1"]'); if(minus) minus.disabled = !n;
        if(nowy && z.getAttribute('data-w') === String(nowy)) skok(z.querySelector('.zw__foto'));
      });
      /* progi: zaznaczony ten, w który wpada liczba zestawów; cena za sztukę liczona od ostatnio wybranej wersji */
      var srednia = (WYB && WYB.ok ? WYB : WAR[0]).cena;
      PROGI.forEach(function(p){
        var n = Number(p.getAttribute('data-prog')), on = t > 0 && Math.min(t, MAXP) === n, nn = n === MAXP && t > MAXP ? t : n;
        p.setAttribute('aria-checked', String(on)); p.tabIndex = on || (!t && n === 1) ? 0 : -1;
        var sz = p.querySelector('[data-prog-szt]'); if(sz) sz.textContent = zl((srednia * nn - rabatZa(nn)) / nn) + '/szt.';
      });
      var pasek = $('zstPasek'); if(pasek) pasek.style.width = (Math.min(t, MAXP) / MAXP * 100) + '%';
      /* podpowiedź: ile brakuje do następnego progu */
      var rada = '', nast = 0;
      for(var k = t + 1; k <= MAXP; k++){ if(rabatZa(k) > rab){ nast = k; break; } }
      if(!t) rada = '👆 Dodaj plusem zestaw, który chcesz. Możesz łączyć wersje.';
      else if(nast) rada = '🎁 Dodaj jeszcze ' + zestawy(nast - t) + ', a rabat wzrośnie do ' + zlk(rabatZa(nast)) + '.';
      else rada = '🎉 Masz najwyższy rabat: -' + zlk(rab) + '. Taniej już się nie da!';
      var rEl = $('zstRada'); if(rEl && rEl.textContent !== rada){ rEl.textContent = rada; skok(rEl, 'skok'); }
      var wyb = $('zstWybrane');
      if(wyb) wyb.innerHTML = wybrane.length ? wybrane.map(function(w){ return '<span>' + ILE[w.id] + '× ' + esc(w.t) + '</span>'; }).join('') : '<span class="pusto">Nic jeszcze nie wybrano</span>';
      var rl = $('zstRabatL'); if(rl) rl.hidden = !rab;
      if(rab){ wpisz('zstRabatOpis', 'Rabat za ' + (t >= MAXP ? MAXP + '+' : t) + ' zestawy'); wpisz('zstRabat', '-' + zlk(rab)); }
      var bz = $('zstBez'); if(bz) bz.textContent = rab ? zl(bez) : '';
      var rz = $('zstRazem'); if(rz){ rz.textContent = zl(razem); if(t !== przed) skok(rz, 'skok'); }
      var sz = $('zstSzt'); if(sz){ sz.hidden = t < 2 || !rab; sz.textContent = 'Wychodzi ' + zl(razem / Math.max(t, 1)) + ' za zestaw zamiast ' + zl(bez / Math.max(t, 1)); }
      /* przyciski i pasek na dole */
      var bt = $('doKoszyka');
      if(bt){ bt.disabled = !t; wpisz('kupBtnTxt', t ? (t === 1 ? 'Dodaj do koszyka' : 'Dodaj ' + zestawy(t)) + ' · ' + zl(razem) : 'Wybierz zestaw'); }
      var nazwa = $('stickyModel'); if(nazwa) nazwa.textContent = t ? zestawy(t) + ' · ' + wybrane.map(function(w){ return w.t; }).join(' + ') : 'Wybierz zestaw';
      var sc = $('stickyCena'); if(sc) sc.innerHTML = zl(razem) + (rab ? '<s>' + zl(bez) + '</s>' : '');
      /* nowy próg rabatu: podskok i konfetti */
      if(przed !== undefined && t > przed && rabatZa(t) > rabatZa(przed)){
        var cel = null; PROGI.forEach(function(p){ if(p.getAttribute('aria-checked') === 'true') cel = p; });
        skok(cel); konfetti(cel);
        try{ if(navigator.vibrate) navigator.vibrate([12, 40, 12]); }catch(er){}
      }
    };
    var zmien = function(id, d){
      var w = wInfo(id); if(!w || !w.ok) return false;
      var n = ILE[w.id] || 0, t = suma();
      if(d > 0 && (n >= MAX_W || t >= MAX_RAZEM)) return false;
      if(d < 0 && !n) return false;
      ILE[w.id] = n + d;
      if(d > 0) KOLEJ.push(w.id); else { var i = KOLEJ.lastIndexOf(w.id); if(i > -1) KOLEJ.splice(i, 1); }
      ost = w.id;
      return true;
    };
    var klik = function(id, d){
      var przed = suma();
      if(!zmien(id, d)) return;
      if(d > 0){ var w = wInfo(id); WYB = w; pokazWersje(w); przewinPudlo(w.id); }
      try{ if(navigator.vibrate) navigator.vibrate(8); }catch(er){}
      rysujZst(d > 0 ? id : null, przed);
    };
    /* zdjęcie innej wersji w galerii: jedna wersja w wyborze = zamieniamy ją całą (ta sama liczba), kilka wersji = podmieniamy ostatnio dodaną */
    naZdjecieWersji = function(id){
      var w = wInfo(id); if(!w || !w.ok) return;
      var przed = suma(), rozne = Object.keys(ILE).filter(function(k){ return ILE[k] > 0; });
      if(!przed) zmien(w.id, 1);
      else if(rozne.length === 1){
        if(rozne[0] !== String(w.id)){ var n = ILE[rozne[0]]; ILE = {}; KOLEJ = []; for(var i = 0; i < n; i++) zmien(w.id, 1); }
      } else if(!ILE[w.id]){ zmien(KOLEJ[KOLEJ.length - 1], -1); zmien(w.id, 1); }
      WYB = w; ost = w.id;
      rysujZst(w.id, przed);
      przewinPudlo(w.id);
    };
    /* klik w próg: dokładamy ostatnio wybraną wersję albo zdejmujemy ostatnio dodane */
    var ustawSume = function(n){
      var przed = suma(), dodaj1 = ost || (WYB && WYB.ok ? WYB.id : null);
      if(!dodaj1) WAR.forEach(function(w){ if(!dodaj1 && w.ok) dodaj1 = w.id; });
      while(suma() < n && zmien(dodaj1, 1)){}
      while(suma() > n && KOLEJ.length) zmien(KOLEJ[KOLEJ.length - 1], -1);
      ost = dodaj1;
      rysujZst(null, przed);
    };
    ZST.addEventListener('click', function(e){
      var b = e.target.closest('[data-zw]'), p = e.target.closest('[data-prog]');
      if(b && !b.disabled){ klik(b.closest('[data-w]').getAttribute('data-w'), Number(b.getAttribute('data-zw'))); }
      if(p){ var n = Number(p.getAttribute('data-prog')); ustawSume(n === MAXP && suma() > MAXP ? suma() : n); skok(p); }
    });
    ZST.addEventListener('keydown', function(e){
      var p = e.target.closest('[data-prog]'); if(!p) return;
      var k = { ArrowRight: 1, ArrowDown: 1, ArrowLeft: -1, ArrowUp: -1 }[e.key]; if(!k) return;
      e.preventDefault(); var i = PROGI.indexOf(p), nb = PROGI[Math.max(0, Math.min(PROGI.length - 1, i + k))];
      ustawSume(Number(nb.getAttribute('data-prog'))); nb.focus();
    });
    /* start: wersja z adresu (albo pierwsza) i ewentualnie druga, żeby od razu był rabat za 2 */
    (ZST.getAttribute('data-start') || '').split(',').forEach(function(id){ if(id) zmien(id.trim(), 1); });
    ost = WYB && WYB.ok ? WYB.id : ost;
    rysujZst();
    if(WYB) przewinPudlo(WYB.id, true);
    var dodajZestaw = function(e){
      e.preventDefault();
      var items = []; WAR.forEach(function(w){ if(ILE[w.id]) items.push({ id: w.id, quantity: ILE[w.id] }); });
      if(!items.length){ $('kup').scrollIntoView({ behavior: redukcja ? 'auto' : 'smooth', block: 'start' }); skok($('zstRada'), 'skok'); return; }
      dodajIOtworz(items, this);
    };
    if($('doKoszyka')) $('doKoszyka').addEventListener('click', dodajZestaw);
    if($('stickyDodaj')) $('stickyDodaj').addEventListener('click', dodajZestaw);
    /* przyciski z innych sekcji: wersja (Safari z sekcji Safari), Duo, liczba zestawów */
    document.addEventListener('click', function(e){
      var a = e.target.closest('[data-wybierz-wariant]'), p = e.target.closest('[data-pakiet]'), pd = e.target.closest('[data-pudlo-dodaj]');
      if(pd){ klik(pd.getAttribute('data-pudlo-dodaj'), 1); skok(pd); }
      if(a){
        var t = a.getAttribute('data-wybierz-wariant').toLowerCase(), przed = suma();
        WAR.forEach(function(w){ if(w.t.toLowerCase() === t && !ILE[w.id]){ zmien(w.id, 1); WYB = w; } });
        rysujZst(WYB && WYB.id, przed);
      }
      if(p){
        e.preventDefault();
        var v = p.getAttribute('data-pakiet');
        if(v === 'duo' && duoOk()){ var pr = suma(); ILE = {}; KOLEJ = []; zmien(WAR[0].id, 1); zmien(WAR[1].id, 1); rysujZst(null, pr); }
        else if(Number(v)) ustawSume(Number(v));
        $('kup').scrollIntoView({ behavior: redukcja ? 'auto' : 'smooth', block: 'start' });
      }
    });
  }

  /* ══ ŚCIŚNIJ MNIE: łapka na stronie ══ */
  var lapka = $('lapka'), licznik = 0, KOL = ['#FF78B4', '#B395FF', '#3FC495', '#FFC94D', '#7CC4FF'];
  function iskry(x, y){
    if(redukcja || !Element.prototype.animate) return;
    var pole = lapka.parentNode, r = pole.getBoundingClientRect();
    for(var i = 0; i < 9; i++){
      var s = document.createElement('span'); s.className = 'iskra';
      var kat = Math.random() * Math.PI * 2, d = 60 + Math.random() * 80;
      s.style.background = KOL[i % KOL.length];
      s.style.left = (x - r.left - 5) + 'px'; s.style.top = (y - r.top - 5) + 'px';
      pole.appendChild(s);
      s.animate([{ transform: 'translate(0,0) scale(1)', opacity: 1 }, { transform: 'translate(' + Math.cos(kat) * d + 'px,' + Math.sin(kat) * d + 'px) scale(.2)', opacity: 0 }],
        { duration: 600 + Math.random() * 300, easing: 'cubic-bezier(.2,.7,.3,1)' }).onfinish = (function(el){ return function(){ el.remove(); }; })(s);
    }
  }
  var HASLA = { 5: 'Jeszcze raz! Nie da się przestać.', 15: 'Prawdziwy jest jeszcze miększy.', 30: 'Okej, potrzebujesz 6 takich.' };
  if(lapka){
    var wcisk = function(x, y){
      lapka.classList.add('wcisk');
      licznik++; wpisz('sciskLicznik', String(licznik));
      if(HASLA[licznik]) wpisz('sciskHint', HASLA[licznik]);
      try{ if(navigator.vibrate) navigator.vibrate(12); }catch(er){}
      iskry(x, y);
    };
    var pusc = function(){ lapka.classList.remove('wcisk'); };
    lapka.addEventListener('pointerdown', function(e){ e.preventDefault(); wcisk(e.clientX, e.clientY); });
    ['pointerup', 'pointerleave', 'pointercancel'].forEach(function(t){ lapka.addEventListener(t, pusc); });
    lapka.addEventListener('keydown', function(e){
      if(e.key !== ' ' && e.key !== 'Enter') return;
      e.preventDefault();
      if(lapka.classList.contains('wcisk')) return;
      var r = lapka.getBoundingClientRect(); wcisk(r.left + r.width / 2, r.top + r.height / 2); setTimeout(pusc, 160);
    });
  }

  /* ══ ZBUDUJ WIEŻĘ: każde stuknięcie zrzuca żelowy klocek, po „max” wieża się rozsypuje ══ */
  var wieza = $('wieza'), stos = $('wiezaStos');
  if(wieza && stos){
    var maxW = Number(wieza.getAttribute('data-max')) || 12, ileW = 0, rozsypuje = false, haslaW = {}, hint0 = ($('wiezaHint') || {}).textContent;
    (wieza.getAttribute('data-hasla') || '').split(/\n/).forEach(function(l){ var m = l.match(/^\s*(\d+)\s*:\s*(.+)$/); if(m) haslaW[m[1]] = m[2]; });
    var iskryW = function(x, y){
      if(redukcja || !Element.prototype.animate) return;
      var r = wieza.getBoundingClientRect();
      for(var i = 0; i < 8; i++){
        var s = document.createElement('span'); s.className = 'iskra';
        var kat = Math.random() * Math.PI * 2, d = 50 + Math.random() * 70;
        s.style.background = KOL[i % KOL.length]; s.style.left = (x - r.left - 5) + 'px'; s.style.top = (y - r.top - 5) + 'px';
        wieza.appendChild(s);
        s.animate([{ transform: 'translate(0,0) scale(1)', opacity: 1 }, { transform: 'translate(' + Math.cos(kat) * d + 'px,' + Math.sin(kat) * d + 'px) scale(.2)', opacity: 0 }],
          { duration: 550 + Math.random() * 250, easing: 'cubic-bezier(.2,.7,.3,1)' }).onfinish = (function(el){ return function(){ el.remove(); }; })(s);
      }
    };
    var rozsyp = function(){
      rozsypuje = true;
      [].forEach.call(stos.children, function(k, i){
        k.classList.add('rozsyp');
        k.style.transform = 'translate(' + ((Math.random() - .5) * 420) + 'px,' + (120 + Math.random() * 160) + 'px) rotate(' + ((Math.random() - .5) * 220) + 'deg)';
        k.style.opacity = '0';
      });
      setTimeout(function(){ stos.innerHTML = ''; ileW = 0; wpisz('wiezaLicznik', '0'); wpisz('wiezaHint', hint0); rozsypuje = false; }, 850);
    };
    var dolozW = function(){
      if(rozsypuje) return;
      if(ileW >= maxW){ rozsyp(); return; }
      ileW++;
      var k = document.createElement('span'), w = [1, 2, 2, 3, 4][Math.floor(Math.random() * 5)];
      k.className = 'kl kl--' + (1 + (ileW - 1) % 4);
      k.style.setProperty('--w', w);
      k.style.marginLeft = k.style.marginRight = '0';
      k.style.left = ((Math.random() - .5) * 26) + 'px';
      stos.appendChild(k);
      wpisz('wiezaLicznik', String(ileW));
      if(haslaW[ileW]) wpisz('wiezaHint', haslaW[ileW]);
      try{ if(navigator.vibrate) navigator.vibrate(10); }catch(er){}
      if(!redukcja && k.animate){
        k.animate([
          { transform: 'translateY(-' + (260 + ileW * 6) + 'px) rotate(' + ((Math.random() - .5) * 24) + 'deg)', opacity: .4 },
          { transform: 'translateY(0) scale(1.18,.78)', opacity: 1, offset: .62 },
          { transform: 'translateY(-10px) scale(.92,1.1)', offset: .8 },
          { transform: 'translateY(0) scale(1.04,.96)', offset: .92 },
          { transform: 'none' }
        ], { duration: 620, easing: 'cubic-bezier(.3,.6,.4,1)' }).onfinish = function(){
          var r = k.getBoundingClientRect(); iskryW(r.left + r.width / 2, r.top + r.height / 2);
          stos.animate([{ transform: 'rotate(0deg)' }, { transform: 'rotate(' + (ileW > maxW - 3 ? 2.4 : 1) + 'deg)' }, { transform: 'rotate(-' + (ileW > maxW - 3 ? 2 : .8) + 'deg)' }, { transform: 'none' }], { duration: 520, easing: 'ease-out' });
        };
      }
    };
    wieza.addEventListener('pointerdown', function(e){ e.preventDefault(); wieza.classList.add('wcisk'); dolozW(); });
    ['pointerup', 'pointerleave', 'pointercancel'].forEach(function(t){ wieza.addEventListener(t, function(){ wieza.classList.remove('wcisk'); }); });
    wieza.addEventListener('keydown', function(e){ if(e.key === ' ' || e.key === 'Enter'){ e.preventDefault(); dolozW(); } });
  }

  /* ══ SAFARI: figurki podskakują i „mówią” ══ */
  var dymek = $('safariDymek');
  document.querySelectorAll('.figurka').forEach(function(f){
    f.addEventListener('click', function(){
      f.classList.remove('hop'); void f.offsetWidth; f.classList.add('hop');
      if(dymek){ dymek.textContent = f.getAttribute('data-nazwa') + ': ' + f.getAttribute('data-glos'); dymek.classList.remove('skok'); void dymek.offsetWidth; dymek.classList.add('skok'); }
      try{ if(navigator.vibrate) navigator.vibrate(10); }catch(er){}
    });
  });

  /* linki do sekcji: płynne przewinięcie */
  document.querySelectorAll('a[href^="#"]').forEach(function(a){
    a.addEventListener('click', function(e){
      var h = a.getAttribute('href');
      if(h.length < 2) return;
      var c = document.querySelector(h);
      if(!c) return;
      e.preventDefault();
      c.scrollIntoView({ behavior: redukcja ? 'auto' : 'smooth', block: 'start' });
    });
  });

  /* ══ ODSŁANIANIE (w edytorze motywu wszystko widać od razu) ══ */
  var el = [].slice.call(document.querySelectorAll('.odsl'));
  if('IntersectionObserver' in window && !redukcja && !(window.Shopify && Shopify.designMode)){
    var obs = new IntersectionObserver(function(w){ w.forEach(function(x){ if(x.isIntersecting){ x.target.classList.add('on'); obs.unobserve(x.target); } }); }, { rootMargin: '0px 0px -8% 0px', threshold: 0.06 });
    el.forEach(function(e){ obs.observe(e); });
  } else el.forEach(function(e){ e.classList.add('on'); });
  setTimeout(function(){ el.forEach(function(e){ if(e.getBoundingClientRect().top < innerHeight * 1.2) e.classList.add('on'); }); }, 1200);

  /* ══ OPINIE ══ */
  var tor = $('tor');
  document.querySelectorAll('[data-tor]').forEach(function(b){
    b.addEventListener('click', function(){ var k = tor.querySelector('.opinia'); tor.scrollBy({ left: (k ? k.offsetWidth + 18 : 320) * Number(b.getAttribute('data-tor')), behavior: redukcja ? 'auto' : 'smooth' }); });
  });

  /* ══ FAQ: płynne otwieranie, jedno otwarte ══ */
  document.querySelectorAll('.faq details').forEach(function(d){
    var summary = d.querySelector('summary'), tresc = d.querySelector('.faq-t');
    summary.addEventListener('click', function(e){
      if(redukcja || !Element.prototype.animate) return;
      e.preventDefault();
      if(d.open){
        tresc.animate([{ height: tresc.offsetHeight + 'px', opacity: 1 }, { height: '0px', opacity: 0 }], { duration: 240, easing: 'ease' }).onfinish = function(){ d.open = false; };
      } else {
        document.querySelectorAll('.faq details[open]').forEach(function(x){ if(x !== d) x.open = false; });
        d.open = true;
        var h = tresc.offsetHeight;
        tresc.animate([{ height: '0px', opacity: 0 }, { height: h + 'px', opacity: 1 }], { duration: 320, easing: 'cubic-bezier(.2,.7,.3,1)' });
      }
    });
  });

  /* ══ PASEK NA DOLE ══ */
  var sticky = $('sticky'), kup = $('kup');
  function odswiez(){
    if(!sticky) return;
    var wKup = false;
    if(kup){ var r = kup.getBoundingClientRect(); wKup = r.top < innerHeight && r.bottom > 0; }
    var f = $('final'), wFinal = false;
    if(f){ var rf = f.getBoundingClientRect(); wFinal = rf.top < innerHeight * .8; }
    sticky.classList.toggle('on', scrollY > innerHeight * .9 && !wKup && !wFinal);
  }
  var czeka = false;
  addEventListener('scroll', function(){ if(czeka) return; czeka = true; requestAnimationFrame(function(){ odswiez(); czeka = false; }); }, { passive: true });
  odswiez();

  /* ══ FILMY: grają tylko, gdy są na ekranie ══ */
  var filmy = [].slice.call(document.querySelectorAll('[data-film]'));
  if(filmy.length && 'IntersectionObserver' in window){
    var obsF = new IntersectionObserver(function(w){ w.forEach(function(x){
      var v = x.target;
      if(x.isIntersecting){ if(v.preload === 'none'){ v.preload = 'auto'; v.load(); } var pr = v.play(); if(pr && pr.catch) pr.catch(function(){}); }
      else v.pause();
    }); }, { threshold: .35 });
    filmy.forEach(function(v){ obsF.observe(v); });
  }

  /* ══ STRONA GŁÓWNA: karta produktu z wersjami, miniatura zmienia zdjęcie, opis, cenę i link ══ */
  document.querySelectorAll('[data-karta]').forEach(function(k){
    var wersje = k.querySelector('.karta__wersje');
    if(!wersje) return;
    wersje.addEventListener('click', function(e){
      var b = e.target.closest('button[data-url]'); if(!b) return;
      wersje.querySelectorAll('button').forEach(function(x){ x.setAttribute('aria-checked', String(x === b)); });
      var img = k.querySelector('.karta__foto img');
      if(img && b.getAttribute('data-img')){ img.removeAttribute('srcset'); img.src = b.getAttribute('data-img'); }
      k.querySelectorAll('[data-k-link]').forEach(function(a){ a.href = b.getAttribute('data-url'); });
      var t = function(sel, v){ var el = k.querySelector(sel); if(el) el.textContent = v; };
      t('[data-k-nazwa]', b.getAttribute('data-t')); t('[data-k-opis]', b.getAttribute('data-opis'));
      t('[data-k-cena]', b.getAttribute('data-cena')); t('[data-k-c2]', b.getAttribute('data-c2'));
      if(!redukcja){ var f = k.querySelector('.karta__foto'); f.classList.remove('hop'); void f.offsetWidth; f.classList.add('hop'); }
    });
  });

  /* ══ STRONA /cart: zapamiętujemy ostatnią stronę sklepu; /cart wraca na nią z dopiskiem #koszyk, który otwiera wysuwany koszyk ══ */
  if(!/^\/(cart|checkouts|account)/.test(location.pathname)){ try{ localStorage.setItem('pf_wroc', location.pathname + location.search); }catch(er){} }
  if(location.hash === '#koszyk'){
    try{ history.replaceState(null, '', location.pathname + location.search); }catch(er){}
    pobierzKoszyk().catch(function(){ rysujKosz(); }).then(otworz);
  } else pobierzKoszyk().catch(function(){ rysujKosz(); });
})();
